<template>
  <div>
    <base-section-heading 
      color="grey lighten-2"
      icon="mdi-spider-web"
      title="타란툴라 살펴보기"
    />
    <v-responsive
      class="mx-auto"
      max-width="1400"
    >
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <sql-features />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <supported-ds />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </div>
</template>

<script>
  export default {
    name: 'SectionBusinessSql',

    components: {
      SqlFeatures: () => import('@/components/SqlFeatures'),
      SupportedDs: () => import('@/components/SupportedDs'),
      // Instagram: () => import('@/components/Instagram'),
    },
  }
</script>

<style lang="sass">
  #sql-alt a
    text-decoration: none
</style>
